const NODE_ENV = process.env.NODE_ENV;
export default () => NODE_ENV === 'production';
//# sourceMappingURL=is-production.js.map